import { useRouter } from 'next/router';
import { AcceptInvite } from '../../../../components/AcceptInvite';
import { ApplicationCreate } from '../../../../components/ApplicationCreate';
import { TallHeightLoadingMask } from '../../../../styles/css-components';

type QueryProps = {
  listingAlias: string;
  inviteId?: string;
  version?: string;
};
export default function CreateNewApplicationForListingPage() {
  const router = useRouter();
  const { listingAlias, inviteId, version } = router.query as QueryProps;

  return (
    <TallHeightLoadingMask loading={!router.isReady}>
      {router.isReady &&
        (inviteId ? (
          // new invitations will not have an applicationId
          <AcceptInvite listingAlias={listingAlias} inviteId={inviteId} version={version} />
        ) : (
          <ApplicationCreate />
        ))}
    </TallHeightLoadingMask>
  );
}
